/**
 * Converted movies through the relay (#242): how much the relay sends ahead, and when a converted
 * movie that reconnects restarts its conversion at the viewer's position.
 */

/** 4K: the relay sends 10 s ahead instead of 45, so the browser's video buffer (~150 MB) holds it. */
export function headStartFor(height: number | null | undefined): number | undefined {
  return height && height > 1080 ? 10 : undefined;
}

/** Restarts allowed per title within this window; older ones no longer count. */
const RESTART_WINDOW_MS = 10 * 60_000;
const RESTARTS_PER_WINDOW = 5;

/**
 * Where to restart a converted movie that reconnects, or `null` to leave it to the controller's own
 * retries: only when it had played since its last start (a conversion failing at once keeps the
 * controller's growing waits), and at most 5 times in 10 minutes.
 */
export function conversionRestartAt(options: {
  reconnecting: boolean;
  dropped: boolean;
  live: boolean;
  offset: number;
  watchedAt: number;
  restarts: readonly number[];
  now: number;
}): number | null {
  const { reconnecting, dropped, live, offset, watchedAt, restarts, now } = options;
  if (!reconnecting || !dropped || live) return null;
  if (restarts.filter((at) => now - at < RESTART_WINDOW_MS).length >= RESTARTS_PER_WINDOW) return null;
  return Math.max(offset, Math.floor(watchedAt));
}
